const passwordFields = document.querySelectorAll('.form-type-password');

const handleTogglePasswordVisibility = (passwordField) => {
    const passwordInput = passwordField.querySelector('input');
    const passwordToggleButton = passwordField.querySelector('.toggle-password-visibility');
    const srPasswordText = passwordToggleButton.querySelector('.visually-hidden');
    const showPasswordTxt = passwordToggleButton.dataset.showpass;
    const hidePasswordTxt = passwordToggleButton.dataset.hidepass;
    const buttonState = passwordToggleButton.getAttribute('aria-pressed');
    passwordToggleButton.setAttribute('aria-pressed', buttonState === 'false' ? 'true' : 'false');
    srPasswordText.innerText = buttonState === 'true' ? showPasswordTxt : hidePasswordTxt;
    passwordInput.type = buttonState === 'true' ? 'password' : 'text';
    passwordToggleButton.classList.add('active');
};

passwordFields.forEach((passwordField) => {
    const passwordToggleButton = passwordField.querySelector('.toggle-password-visibility');
    passwordToggleButton.addEventListener('click', () => handleTogglePasswordVisibility(passwordField));
});
